var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'block--loading': _vm.loading },style:(_vm.styleSkeletonWrapper)},[(!_vm.loading)?_vm._t("default"):_c('div',{staticClass:"skeleton",style:(_vm.styleSkeleton)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }